module.exports = __webpack_public_path__ + "img/1 (38).d8bc1ce5.png";